export default __webpack_public_path__ + "2319346e937d51fcf45ffacfc11291b5.png";